<div class="chart-js">
  <canvas #scatterChart></canvas>
</div>
